module.exports = __webpack_public_path__ + "z/authentic-desktop.50f46c34.jpg";